import "../../../styles/Auth/report.css";
import { Icon } from "@iconify/react";
import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { getData } from "../../../webService/webservice.js";
import { toast } from "react-toastify";
import { useStore } from "../../../Context/context.jsx";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import html2pdf from "html2pdf.js";
import { useRef } from "react";
import { uploadFile, postData } from "../../../webService/webservice.js";
import Swal from "sweetalert2";
import "../../../styles/Auth/eod.css";

const EndOfDayReport = () => {
    const reportRef = useRef(null);
    const { startDate, endDate } = useOutletContext();
    const [summary, setSummary] = useState({});
    const [loading, setLoading] = useState(false);
    const { selectedStoreId } = useStore();
    const [currentStore, setCurrentStore] = useState(null);
    const eod = summary?.eodSummary || {};
    const sessionToken = localStorage.getItem("Token");
    const role = localStorage.getItem("role");

    const fetchEndOfDayReport = async () => {
        try {
            setLoading(true);
            const params = {
                storeId: selectedStoreId,
                startDate: startDate,
                endDate: endDate
            };

            const response = await getData(
                `reports/reports/eod`,
                params,
                sessionToken
            );

            if (response?.success === false || (response?.status && response?.status !== 200)) {
                toast.error(response?.message || "Failed to fetch End of Day Report");
                return;
            }
            console.log("End of Day Report", response?.data);

            setSummary(response?.data || {});
        } catch (error) {
            console.error("❌ Error fetching EOD report:", error);
            toast.error("Something went wrong while fetching End of Day report");
        } finally {
            setLoading(false);
        }
    };

    const productSales =
        summary?.salesBreakdown?.find(
            x => x.salesType === "Product Sales"
        );

    const serviceSales =
        summary?.salesBreakdown?.find(
            x => x.salesType === "Service Sales"
        );

    const membershipSales =
        summary?.salesBreakdown?.find(
            x => x.salesType === "Membership Sales"
        );

    useEffect(() => {
        fetchEndOfDayReport();
    }, [selectedStoreId, startDate, endDate]);

    useEffect(() => {
        const fetchStoreDetails = async () => {
            if (selectedStoreId && selectedStoreId.length === 24) {
                try {
                    const res = await getData(`stores/store/${selectedStoreId}`, {}, sessionToken);
                    if (res?.data) {
                        setCurrentStore(res.data);
                    }
                } catch (error) {
                    console.error("Store detail fetch failed", error);
                }
            }
        };
        fetchStoreDetails();
    }, [selectedStoreId]);

    const handleExport = () => {
        const eod = summary?.eodSummary || {};

        const data = [
            {
                "Opening Cash": eod.openingCash,
                "Cash Sales": eod.cashSales,
                "Card Sales": eod.cardSales,
                "Wallet Sales": eod.walletSales,
                "Service Wallet Recharge": eod.serviceWalletRecharge,
                "Cash Wallet Recharge": eod.cashWalletRecharge,
                "Total Returns": eod.totalReturns,
                "Product Sales": eod.productSales,
                "Service Sales": eod.serviceSales,
                "Products Sold": eod.productsSold,
                "Membership Sold": eod.membershipSold,
                "Expenses": eod.totalExpenses,
                "Purchases": eod.totalPurchases,
                "Bank Transfer": eod.bankTransfer || 0,
                "Self Withdrawal": eod.selfWithdrawal || 0,
                "Closing Cash": eod.closingCash
            }
        ];

        const worksheet =
            XLSX.utils.json_to_sheet(data);

        const workbook =
            XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "EOD Report"
        );

        const excelBuffer =
            XLSX.write(
                workbook,
                {
                    bookType: "xlsx",
                    type: "array"
                }
            );

        const fileData = new Blob(
            [excelBuffer],
            {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        );

        saveAs(
            fileData,
            `EOD_Report_${new Date()
                .toISOString()
                .split("T")[0]}.xlsx`
        );
    };

    const generateReceiptHTML = () => {
        const eod = summary?.eodSummary || {};

        return `
    <div style="
        width:80mm;
        padding:10px;
        font-family:Courier New, monospace;
        font-size:12px;
        color:#000;
    ">

        <center>
            <h3>${currentStore?.storeName || ""}</h3>
            <div>${currentStore?.branchName || ""}</div>
            <div>${currentStore?.address || ""}</div>
            <div>${currentStore?.phoneNumber || ""}</div>

            <hr/>

            <h3>END OF DAY REPORT</h3>

            <div>
                ${startDate} To ${endDate}
            </div>
        </center>

        <hr/>

        <b>SALES SUMMARY</b>
        <table width="100%">
<tr>
    <td>Total Bills</td>
    <td align="right">${eod.invoiceCount || 0}</td>
</tr>

<tr>
    <td>Total Sales</td>
    <td align="right">₹${(eod.totalNetSales || 0).toFixed(2)}</td>
</tr>

<tr>
    <td>Cancelled</td>
    <td align="right">${eod.totalCancelled || 0}</td>
</tr>

<tr>
    <td>Returns</td>
    <td align="right">₹${(eod.totalReturns || 0).toFixed(2)}</td>
</tr>

<tr>
    <td>GST</td>
    <td align="right">₹${(eod.totalGST || 0).toFixed(2)}</td>
</tr>
        </table>

        <hr/>

        <b>PAYMENT SUMMARY</b>
        <table width="100%">
            <tr>
                <td>Cash</td>
                <td align="right">₹${(eod.cashSales || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>Card</td>
                <td align="right">₹${(eod.cardSales || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>UPI</td>
                <td align="right">₹${(eod.upiSales || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>Wallet Sales (Usage)</td>
                <td align="right">₹${(eod.walletSales || 0).toFixed(2)}</td>
            </tr>
            <tr>
                <td>Service Wallet Recharge</td>
                <td align="right">₹${(eod.serviceWalletRecharge || 0).toFixed(2)}</td>
            </tr>
            <tr>
                <td>Cash Wallet Recharge</td>
                <td align="right">₹${(eod.cashWalletRecharge || 0).toFixed(2)}</td>
            </tr>
        </table>

        <hr/>

        <b>PRODUCT & SERVICE</b>
        <table width="100%">
            <tr>
                <td>Product Sales</td>
                <td align="right">₹${(eod.productSales || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>Products Sold</td>
                <td align="right">${eod.productsSold || 0}</td>
            </tr>

            <tr>
                <td>Service Sales</td>
                <td align="right">₹${(eod.serviceSales || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>Membership Sold</td>
                <td align="right">${eod.membershipSold || 0}</td>
            </tr>
        </table>

        <hr/>

        <b>CUSTOMER SUMMARY</b>
        <table width="100%">
            <tr>
                <td>Total Customers</td>
                <td align="right">${summary.customers?.totalCustomers || 0}</td>
            </tr>

            <tr>
                <td>New Customers</td>
                <td align="right">
                    ${(summary.customers?.newWithMembership || 0) +
            (summary.customers?.newWithoutMembership || 0)}
                </td>
            </tr>

            <tr>
                <td>Existing Customers</td>
                <td align="right">
                    ${(summary.customers?.existingWithMembership || 0) +
            (summary.customers?.existingWithoutMembership || 0)}
                </td>
            </tr>
        </table>

        <hr/>

        <b>EXPENSE SUMMARY</b>
        <table width="100%">
            <tr>
                <td>Expenses</td>
                <td align="right">₹${(eod.totalExpenses || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>Purchases</td>
                <td align="right">₹${(eod.totalPurchases || 0).toFixed(2)}</td>
            </tr>
        </table>

        <hr/>

        <b>CASH FLOW</b>
        <table width="100%">
            <tr>
                <td>Opening Cash</td>
                <td align="right">₹${(eod.openingCash || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>(-) Bank Transfer</td>
                <td align="right">₹${(eod.bankTransfer || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>(-) Self Withdrawal</td>
                <td align="right">₹${(eod.selfWithdrawal || 0).toFixed(2)}</td>
            </tr>

            <tr>
                <td>Closing Cash</td>
                <td align="right">₹${(eod.closingCash || 0).toFixed(2)}</td>
            </tr>
        </table>

        <hr/>

        <center>
            Generated By
            <br/>
            ${localStorage.getItem("name") || ""}
            <br/><br/>
            ${new Date().toLocaleString()}
            <br/><br/>
            *** END OF REPORT ***
        </center>

    </div>
    `;
    };



    const handlePrint = async () => {
        let skipCloseDay = false;

        if (summary?.isDayClosed) {
            const result = await Swal.fire({
                icon: "warning",
                title: "Day Already Closed",
                text: "EOD already closed for this date. Would you like to send the EOD report mail anyway?",
                showCancelButton: true,
                confirmButtonText: "Send Mail",
                cancelButtonText: "OK",
                confirmButtonColor: "#3C0008",
                cancelButtonColor: "#64748b"
            });

            if (result.isConfirmed) {
                skipCloseDay = true;
            } else {
                return;
            }
        } else {
            const result = await Swal.fire({
                title: "Close Day ?",
                html: `
            <div style="text-align:left;">
                <p>
                    EOD Report will be generated,
                    emailed and the day will be closed.
                </p>

                <br/>

                <b>Important:</b>

                <ul>
                    <li>Opening Cash will be locked</li>
                    <li>Closing Cash will be saved</li>
                    <li>EOD cannot be closed twice</li>
                </ul>
            </div>
        `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Close Day",
                cancelButtonText: "Cancel"
            });

            if (!result.isConfirmed) {
                return;
            }
        }
        try {

            if (!reportRef.current) {
                toast.error("Report not found");
                return;
            }

            const userId = localStorage.getItem("userId");

            /* -----------------------
               Generate PDF
            ----------------------- */

            const receiptHtml = generateReceiptHTML();

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = receiptHtml;
            document.body.appendChild(tempDiv);

            const pdfBlob = await html2pdf()
                .set({
                    margin: 2,
                    filename: "EOD_Report.pdf",
                    image: {
                        type: "jpeg",
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2
                    },
                    jsPDF: {
                        unit: "mm",
                        format: [80, 300],
                        orientation: "portrait"
                    }
                })
                .from(tempDiv)
                .outputPdf("blob");

            document.body.removeChild(tempDiv);

            /* -----------------------
               Upload PDF
            ----------------------- */

            const pdfFile = new File(
                [pdfBlob],
                "EOD_Report.pdf",
                {
                    type: "application/pdf"
                }
            );

            const uploadRes = await uploadFile(
                `files/upload/${userId}`,
                pdfFile
            );

            console.log("UPLOAD RESPONSE", uploadRes);

            if (
                !uploadRes ||
                uploadRes.success === false ||
                !uploadRes.data
            ) {
                toast.error("PDF upload failed");
                return;
            }

            /* -----------------------
               Send Mail
            ----------------------- */

            const mailPayload = {
                storeId: selectedStoreId,
                startDate,
                endDate,
                pdfPath: uploadRes.data.path
            };

            console.log("Mail Payload =>", mailPayload);

            const mailRes = await postData(
                "reports/send-eod-mail",
                mailPayload,
                sessionToken
            );

            console.log("Mail Response =>", mailRes);

            if (
                mailRes?.success === false ||
                mailRes?.status >= 400
            ) {
                toast.error(
                    mailRes?.message ||
                    "Failed to send EOD Report"
                );
                return;
            }

            /* -----------------------
               Success
            ----------------------- */

            toast.success(
                "EOD Report mailed successfully"
            );

            /* -----------------------
            SAVE EOD SNAPSHOT
            ----------------------- */

            if (!skipCloseDay) {
                const closeDayPayload = {
                    storeId: selectedStoreId,
                    reportDate: startDate,
                    pdfPath: uploadRes.data.path,
                    eodSummary: summary.eodSummary
                };

                const closeDayRes = await postData(
                    "eod/close-day",
                    closeDayPayload,
                    sessionToken
                );

                console.log(
                    "Close Day Response =>",
                    closeDayRes
                );

                if (
                    closeDayRes?.success === false ||
                    closeDayRes?.status >= 400
                ) {
                    toast.error(
                        closeDayRes?.message ||
                        "Failed to close day"
                    );
                    return;
                }
            }

            /* -----------------------
               Open Print Dialog
            ----------------------- */

            const pdfUrl = URL.createObjectURL(pdfBlob);

            const printWindow = window.open(pdfUrl);

            if (printWindow) {
                printWindow.onload = () => {
                    printWindow.focus();
                    printWindow.print();
                };
            }

        } catch (error) {

            console.error(
                "EOD Report Error =>",
                error
            );

            toast.error(
                error?.response?.data?.message ||
                error?.message ||
                "Failed to send EOD Report"
            );
        }
    };
    const reportCards = [
        {
            title: "Opening Cash",
            value: `${(eod.openingCash || 0).toFixed(2)}`,
            icon: "mdi:wallet",
            themeClass: "card-theme-blue"
        },
        {
            title: "Cash Sales",
            value: `${(eod.cashSales || 0).toFixed(2)}`,
            icon: "mdi:cash",
            themeClass: "card-theme-green"
        },
        {
            title: "Card Sales",
            value: `${(eod.cardSales || 0).toFixed(2)}`,
            icon: "mdi:credit-card",
            themeClass: "card-theme-purple"
        },
        {
            title: "UPI Sales",
            value: `${(eod.upiSales || 0).toFixed(2)}`,
            icon: "mdi:qrcode-scan",
            themeClass: "card-theme-indigo"
        },
        {
            title: "Wallet Sales (Usage)",
            value: `${(eod.walletSales || 0).toFixed(2)}`,
            icon: "solar:wallet-money-bold-duotone",
            themeClass: "card-theme-teal"
        },
        {
            title: "Service Wallet Recharge",
            value: `${(eod.serviceWalletRecharge || 0).toFixed(2)}`,
            icon: "mdi:wallet-plus",
            themeClass: "card-theme-blue"
        },
        {
            title: "Cash Wallet Recharge",
            value: `${(eod.cashWalletRecharge || 0).toFixed(2)}`,
            icon: "mdi:cash-plus",
            themeClass: "card-theme-green"
        },
        {
            title: "Net Sales",
            value: `${(eod.totalNetSales || 0).toFixed(2)}`,
            icon: "mdi:chart-line",
            themeClass: "card-theme-orange"
        },
        {
            title: "Product Sales",
            value: `${(eod.productSales || 0).toFixed(2)}`,
            icon: "mdi:package-variant",
            themeClass: "card-theme-blue"
        },
        {
            title: "Service Sales",
            value: `${(eod.serviceSales || 0).toFixed(2)}`,
            icon: "mdi:content-cut",
            themeClass: "card-theme-green"
        },
        {
            title: "Products Sold",
            value: eod.productsSold || 0,
            icon: "mdi:package",
            themeClass: "card-theme-purple"
        },
        {
            title: "Membership Sold",
            value: eod.membershipSold || 0,
            icon: "mdi:account-star",
            themeClass: "card-theme-indigo"
        },
        {
            title: "Expenses",
            value: `${(eod.totalExpenses || 0).toFixed(2)}`,
            icon: "mdi:cash-minus",
            themeClass: "card-theme-red"
        },
        {
            title: "Bank Transfer / Self Withdrawal",
            value: `${(eod.totalCashWithdrawals || 0).toFixed(2)}`,
            icon: "mdi:bank-transfer-out",
            themeClass: "card-theme-red"
        },
        {
            title: "Closing Cash",
            value: `${(eod.closingCash || 0).toFixed(2)}`,
            icon: "mdi:cash-lock",
            themeClass: "card-theme-orange"
        }
    ];
    return (
        <div className="summary-main-clean">
            <div
                style={{
                    margin: "20px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    background: "#dcfce7",
                    color: "#15803d",
                    padding: "10px 16px",
                    borderRadius: "999px",
                    fontWeight: 600
                }}
            >
                <Icon icon="mdi:check-circle" width="20" />
                End Of Day Summary
            </div>
            <div className="eod-actions-row">
                <button
                    onClick={handlePrint}
                    disabled={loading || !summary?.eodSummary}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: '#3C0008',
                        color: 'white',
                        padding: '20px 20px',
                        marginBottom: '20px',
                        borderRadius: '12px',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 600,
                        boxShadow: '0 4px 6px -1px rgba(60, 0, 8, 0.2)',
                        transition: 'all 0.2s',
                        opacity: (loading || !summary.totalSales) ? 0.6 : 1
                    }}
                >
                    <Icon icon="mdi:email-outline" width="20" /> Share Report
                </button>

                <button
                    onClick={handleExport}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: "#6d28d9",
                        color: "#fff",
                        border: "none",
                        padding: '20px 20px',
                        marginBottom: '20px',
                        borderRadius: '12px',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 600,
                        boxShadow: '0 4px 6px -1px rgba(60, 0, 8, 0.2)',
                        transition: 'all 0.2s',
                    }}
                >
                    <Icon icon="mdi:file-excel" />
                    Export Excel
                </button>
            </div>
            {loading ? (
                <div style={{ height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>
                    <span>Loading report data...</span>
                </div>
            ) : (
                <div ref={reportRef}>
                    <div className="report-grid-clean">
                        {reportCards.map((card, index) => (
                            <div key={index} className={`report-card-clean ${card.themeClass}`}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ color: '#64748b', fontSize: '14px', fontWeight: 600 }}>{card.title}</span>
                                    <div className="report-stat-icon-wrapper">
                                        <Icon icon={card.icon} width="24" height="24" />
                                    </div>
                                </div>
                                <span style={{ fontSize: '28px', fontWeight: 700, color: '#1e293b' }}>{card.value}</span>
                                {card.count && <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 500 }}>{card.count}</span>}
                            </div>
                        ))}
                    </div>
                    <div className="eod-tables-grid">

                        <div className="eod-table-card">
                            <h3>Payment Summary</h3>

                            <table className="eod-table">
                                <thead>
                                    <tr>
                                        <th>Payment Type</th>
                                        <th>Sales Amount</th>

                                    </tr>
                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Cash</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.cashSales || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>
                                        <td>Card</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.cardSales || 0).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>UPI</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.upiSales || 0).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Wallet</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.walletSales || 0).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Service Wallet Recharge</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.serviceWalletRecharge || 0).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Cash Wallet Recharge</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.cashWalletRecharge || 0).toFixed(2)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Others</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.otherSales || 0).toFixed(2)}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <div className="eod-table-card">
                            <h3>Sales Breakdown</h3>

                            <table className="eod-table">
                                <thead>
                                    <tr>
                                        <th>Sales Type</th>
                                        <th>Amount</th>
                                        <th>Count</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>Product Sales</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(productSales?.amount || 0).toFixed(2)}</td>
                                        <td>{productSales?.count || 0}</td>
                                    </tr>

                                    <tr>
                                        <td>Service Sales</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(serviceSales?.amount || 0).toFixed(2)}</td>
                                        <td>{serviceSales?.count || 0}</td>
                                    </tr>

                                    <tr>
                                        <td>Membership Sales</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(membershipSales?.amount || 0).toFixed(2)}</td>
                                        <td>{membershipSales?.count || 0}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="eod-table-card">
                            <h3>Expense Summary</h3>

                            <table className="eod-table">
                                <thead>
                                    <tr>
                                        <th>Expense Type</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Expenses</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.totalExpenses || 0).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>Purchases</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.totalPurchases || 0).toFixed(2)}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <div className="eod-table-card">
                            <h3>Cash Flow Summary</h3>

                            <table className="eod-table">
                                <tbody>

                                    <tr>
                                        <td>Opening Cash</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.openingCash || 0).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>(+) Cash Sales</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.cashSales || 0).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>(+) Card Sales</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.cardSales || 0).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>(+) UPI Sales</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.upiSales || 0).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>(-) Expenses</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.totalCashExpenses || 0).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>(-) Bank Transfer</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.bankTransfer || 0).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>(-) Self Withdrawal</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.selfWithdrawal || 0).toFixed(2)}</td>
                                    </tr>

                                    <tr
                                        style={{
                                            fontWeight: "bold",
                                            background: "#f8fafc"
                                        }}
                                    >
                                        <td>Closing Cash</td>
                                        <td style={{ fontWeight: "700", color: "#0f172a" }}>
                                            {Number(eod.closingCash || 0).toFixed(2)}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>
            )}
        </div >
    );
};

export default EndOfDayReport;
